const Generic = {
  black: "rgb(0, 0, 0)",
  blackT32: "rgba(0, 0, 0, 0.32)",
  blackT40: "rgba(0, 0, 0, 0.04)",
  blackT50: "rgba(0, 0, 0, 0.5)",
  blackT25: "rgba(0, 0, 0, 0.25)",
  blackT15: "rgba(0, 0, 0, 0.15)",
  blackT10: "rgba(0, 0, 0, 0.1)",
  gray19T70: "rgba(19, 19, 19, 0.7)", //#131313
  gray130: "rgb(130, 130, 130)", // #828282
  gray170: "rgb(170, 170, 170)", // #AAAAAA
  gray189: "rgb(189, 189, 189)", // #BDBDBD
  gray209: "rgb(209, 209, 209)", // #d1d1d1
  gray224: "rgb(224, 224, 224)", // #e0e0e0
  gray230: "rgb(230, 230, 230)", // #e6e6e6
  gray237: "rgb(237, 237, 237)", // #ededed
  gray118T10: "rgba(118, 118, 118, 0.10)", //#76767610
  gray41: "rgb(41, 41, 41)", // #292929
  gray50: "rgb(50,50,50)", //#323232
  gray51: "rgb(51, 51, 51)", // #333333
  gray51T20: "rgba(51, 51, 51, 0.2)", // #33333320
  gray54: "rgb(54, 54, 54)", // #363636
  gray54T05: "rgba(54, 54, 54, 0.05)", //#363636 5%
  gray54T10: "rgba(54, 54, 54, 0.1)", //#363636 10%
  gray54T15: "rgba(54, 54, 54, 0.15)", //#363636 15%
  gray54T20: "rgba(54, 54, 54, 0.2)", // #363636 20%
  gray54T40: "rgba(54, 54, 54, 0.4)", // #363636 40%
  gray54T50: "rgba(54, 54, 54, 0.5)", // #363636 50%
  gray54T60: "rgba(54, 54, 54, 0.6)", // #363636 60%
  gray54T80: "rgba(54, 54, 54, 0.8)", // #363636 80%
  gray61: "rgb(61, 61, 61)", // #3d3d3d
  gray79: "rgb(79, 79, 79)", // #4F4F4F
  gray124: "rgba(124, 124, 124, 1)", // #7C7C7C
  gray196: "rgb(196, 196, 196)", // #C4C4C4
  gray204: "rgb(204, 204, 204)", // #CCCCCC
  gray214: "rgb(214,217,223)", //"#D6D9DF"
  gray246T15: "rgba(246, 246, 246, 0.15)", //#f6f6f6,
  gray236: "rgba(236, 236, 236, 1)", // #ECECEC
  green: "rgb(0, 128, 0)", // green
  highnoteBlue: "rgb(100,166,236)", // #64A6EC
  highnotePink: "rgb(247,119,177)", // #F777B1
  pink1: "rgb(251, 119, 156)", // #FB779C
  purple: "rgb(191, 71, 253)", //#BF47FD
  transparent: "rgba(0, 0, 0, 0)", // transparent
  white240: "rgb(240, 240, 240)", // #f0f0f0
  white242: "rgb(242, 242, 242)", // #f2f2f2
  white255: "rgb(255, 255, 255)", // #ffffff
  white253: "rgb(253, 253, 253)", // #fdfdfd
  white255T10: "rgba(255, 255, 255, 0.1)", // #ffffff10
  white255T20: "rgba(255, 255, 255, 0.2)", // #ffffff20
  white255T40: "rgba(255, 255, 255, 0.4)", // #ffffff40
  white255T50: "rgba(255, 255, 255, 0.5)", // #ffffff50
  white255T60: "rgba(255, 255, 255, 0.6)", // #ffffff60
  white255T70: "rgba(255, 255, 255, 0.7)", // #ffffff70
};

const Highnote = {
  black: "rgb(54, 54, 54)", // #363636
  black2: "rgb(73, 73, 73)", // #494949
  blue1: "rgb(113, 196, 230)", // #71C4E6
  blue2: "rgb(77, 112, 245)", // #4D70F5
  blue3: "rgb(115, 163, 234)", // #73A3EA
  blue4: "rgb(124,188,237)", // "#7CBCED"
  blue4T10: "rgba(124,188,237, 0.1)",
  blue4T90: "rgba(124,188,237, 0.9)",
  gray1: "rgb(219, 216, 216)", // #DBD8D8
  offWhite: "rgb(249, 247, 248)", // #F9F7F8
  pink1: "rgb(251, 119, 156)", // #FB779C
  pink2: "rgb(236, 118, 255)", // #EC76FF
  pink2T50: "rgba(236, 118, 255, 0.5)", // #EC76FF50
  pink3: "rgb(251, 119, 152)", // #FB7798
  pink4: "rgb(243, 119, 208)", // #F377D0
  pink5: "rgb(253,135,182)", // #FD87B6
  purple1: "rgb(191, 71, 253)", // #BF47FD
  purple2: "rgb(122, 0, 248)", // #7A00F8
  purple3: "rgb(116, 138, 236)", // #748AEC
  purple4: "rgb(159, 38, 251)", // #9F26FB
  purple5: "rgb(118, 100, 240)", // #7664F0
  purple6: "rgb(73, 0, 177)", //#4900B1
  success: "rgb(74, 199, 73)", // #4AC749
  warning: "rgb(196, 40, 31)", // #C4281F
  white: "rgb(255, 255, 255)", // #FFFFFF
  swipeBar: "rgb(150, 149, 149)", // #969595
  yellow: "rgb(232, 212, 78)",
};

const Text = {
  black: "rgb(0, 0, 0)", // #000
  black50: "rgba(0,0,0,0.5)", //#00000080
  blue: "rgb(6, 47, 115)", // #062F73
  darkPurple: "rgb(68, 15, 95)", // #440f5f
  gray102: "rgb(102, 102, 102)", // #666
  gray130: "rgb(130, 130, 130)", // #828282
  gray41: "rgb(41, 41, 41)", // #292929
  gray51: "rgb(51, 51, 51)", // #333333
  gray54: "rgb(54, 54, 54)", // #363636
  gray79: "rgb(79, 79, 79)", // #4F4F4F
  gray235T60: "rgba(235,2345,235, 0.6)", // #EB29EB
  purple: "rgb(107, 95, 175)", // #6B5FAF
  white255: "rgb(255, 255, 255)", // #ffffff
  white255T60: "rgba(255, 255, 255, 0.6)",
  offWhiteT70: "rgb(249, 247, 248, 0.7)",
};

export default {
  Generic,
  Text,
  Highnote,
};
